<mat-card appearance="outlined" *ngIf="fetchingError">
  <mat-card-content class="row">
    <mat-icon class="no-flex">error</mat-icon>
    <span>Error when fetching transactions. Try again later.</span>
  </mat-card-content>
</mat-card>

<div>
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
</div>

<ng-container *ngIf="transactions$ | async as transactions">
<div class="table-scroll">
<table mat-table [dataSource]="transactions" class="mat-elevation-z8">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td mat-cell *matCellDef="let transaction">
      <app-copiable-info label="Transaction ID" icon="tag" [value]="transaction.id"></app-copiable-info>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let transaction">
      <app-transaction-status [status]="transaction.status"></app-transaction-status>
    </td>
  </ng-container>

  <ng-container matColumnDef="reservationId">
    <th mat-header-cell *matHeaderCellDef>Reservation ID</th>
    <td mat-cell *matCellDef="let transaction">{{transaction.reservationId}}</td>
  </ng-container>

  <ng-container matColumnDef="startTime">
    <th mat-header-cell *matHeaderCellDef>Start Time</th>
    <td mat-cell *matCellDef="let transaction">{{transaction.startTime | date:'medium'}}</td>
  </ng-container>

  <ng-container matColumnDef="endTime">
    <th mat-header-cell *matHeaderCellDef>End Time</th>
    <td mat-cell *matCellDef="let transaction">{{transaction.endTime | date:'medium'}}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let transaction">
      <div class="actions">
        <button mat-icon-button matTooltip="Monitor transaction" (click)="openTransactionMonitor(transaction)">
          <mat-icon>monitor_heart</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Inspect json" (click)="jsonViewerService.openJsonViewer(transaction)">
          <mat-icon>data_object</mat-icon>
        </button>
        <span matTooltip="Stop Transaction">
          <button mat-icon-button [disabled]="!['Started'].includes(transaction.status)" (click)="stopTransaction(transaction.id)">
            <mat-icon>stop</mat-icon>
          </button>
        </span>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['id', 'status', 'startTime', 'endTime', 'actions']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['id', 'status', 'startTime', 'endTime', 'actions'];"></tr>
</table>
</div>
</ng-container>